const STORAGE_KEY = 'localdata'
const CACHE_TIME = 1000 * 60 * 60 * 3

function flush(state, key) {
  if (!key) return;
  const json = JSON.stringify(Object.assign({}, state, { timestamp: Date.now() }))
  localStorage.setItem(key, json)
}

function restore(key) {
  const json = localStorage.getItem(key)
  if (!json) return
  return JSON.parse(json)
}

const ROLE_NAMES = {
  0: '見学',
  5: 'PL',
  10: 'KP・GM'
}

const state = {
  room: null,
  currentCharacterKey: null,
  tableScale: 1.0,
  tableEdit: true,
  muted: false,
  mode: null,
  uid: null,
  role: 0, // 0: gallery, 5: player, 10: master
  inputText: '',
  inputTo: [],
  sceneSearchText: '',
  enableDiceImg: true,
  enableDiceSe: true,
  diceTimestamp: 0,
  diceType: 'default'
}

const mutations = {
  set(state, { key, value }) {
    if (state[key] === undefined) return
    state[key] = value
    flush(state, STORAGE_KEY)
  },
  restore(state, room) {
    try {
      const data = restore(STORAGE_KEY)
      if (data && (data.room !== room || (data.timestamp + CACHE_TIME) < Date.now())) {
        data.room = room
        data.role = 0
        data.mode = null
        data.inputTo = []
        data.currentCharacterKey = null
      }
      Object.assign(state, data)
    } catch(_) {}
    state.room = room
    flush(state, STORAGE_KEY)
  },
  addScale(state) {
    state.tableScale = Math.min(
      ~~(state.tableScale * 10 + 1) / 10,
      2.0
    )
    flush(state, STORAGE_KEY)
  },
  subScale(state) {
    state.tableScale = Math.max(
      ~~(state.tableScale * 10 - 1) / 10,
      0.5
    )
    flush(state, STORAGE_KEY)
  },
  addToList(state, key) {
    if (!state.inputTo.includes(key)) {
      state.inputTo.push(key)
    }
    flush(state, STORAGE_KEY)
  },
  removeToList(state, key) {
    const i = state.inputTo.indexOf(key)
    if (i > -1) {
      state.inputTo.splice(i, 1)
    }
    flush(state, STORAGE_KEY)
  }
}

const getters = {
  currentCharacterKey(state) {
    return state.currentCharacterKey
  },
  tableScale(state) {
    return state.tableScale
  },
  tableEdit(state) {
    return state.tableEdit
  },
  inputText(state) {
    return state.inputText
  },
  inputTo(state) {
    return state.inputTo
  },
  muted(state) {
    return state.muted
  },
  mode(state) {
    return state.mode
  },
  role(state) {
    return state.role
  },
  roleName(state) {
    return ROLE_NAMES[state.role]
  },
  sceneSearchText(state) {
    return state.sceneSearchText
  },
  enableDiceImg(state) {
    return state.enableDiceImg
  },
  enableDiceSe(state) {
    return state.enableDiceSe
  },
  diceTimestamp(state) {
    return state.diceTimestamp
  },
  diceType() {
    return state.diceType
  }
}

const actions = {
  currentCharacterKey({ commit, dispatch, rootGetters }, key) {
    const character = rootGetters['characters/$get'](key)
    const role = rootGetters['local/role']
    commit('set', { key: 'currentCharacterKey', value: key })
    if (role < 10 && character) {
      dispatch('messages/log', `${character.name}が選択されました。`, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
